import { toZonedTime } from 'date-fns-tz' 

// Generate random hex string color.
const randomHex = () => {
  const randomColor = Math.floor(Math.random() * 16777215).toString(16);
  return `#${randomColor}`;
};

// Validate is UTC and valid date.
const isUtcDate = (str) => {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
  const d = new Date(str); 
  return d instanceof Date && !isNaN(d) && d.toISOString() === str; // valid date 
};

export const getTimeZoneFromUtc = (utcString, timeZone="UTC") => {
  if ( !isUtcDate(utcString ) ) {
    return utcString;
  };
  const date = new Date(utcString); 
  return toZonedTime(date, timeZone || 'UTC') || utcString;
};

export const getColor = (key) => {
  switch (key) {
    case 0:
      return "#90728f";
    case 1:
      return "#b9a0b4";
    case 2:
      return "#9d9b3d";
    case 3:
      return "#cecb76";
    case 4:
      return "#e15759";
    case 5:
      return "#ff9888";
    case 6:
      return "#6b6b6b";
    case 7:
      return "#bab2ae";
    case 8:
      return "#dab6af";
    case 9:
      return "#aa8780";
    case 10:
      return "#4f6980";
    case 12:
      return "#849db1";
    case 13:
      return "#a2ceaa";
    case 14:
      return "#638b66";
    case 15:
      return "#b66353";
    case 16:
      return "#d7ce9f";
    case 17:
      return "#7e756d";
    case 18:
      return "#cbe927";
    case 19:
      return "#c395e1";
    case 20:
      return "#AFCCE6";
    case 21:
      return "#F0BE83";
    case 22:
      return "#A5ACB8";
    default:
      return randomHex();
  }
};

export const getScrolling = (length) => {
  switch (true) {
    case (length <= 10):
      return 0.50;
    case (length > 10 && length <= 20):
      return 0.27;
    case (length > 20 && length <= 30):
      return 0.24;
    case (length > 30 && length <= 40):
      return 0.21;
    case (length > 40 && length <= 50):
      return 0.18;
    case (length > 50 && length <= 60):
      return 0.15;
    case (length > 60 && length <= 70):
      return 0.12;
    case (length > 70 && length <= 80):
      return 0.09;
    case (length > 80 && length <= 90):
      return 0.06;
    case (length > 90):
      return 0.03;
    default:
      return 0.01;
  }
};

export const breakString = (str = '', limit = 10) => {
  let brokenString = '';
  for (let i = 0, count = 0; i < str.length; i++) {
    if (count >= limit && str[i] === ' ') {
      count = 0;
      brokenString += '\n';
      continue;
    };
    count++;
    brokenString += str[i];
  };
  return brokenString;
};
